<template src="./contact.html"></template>

<script>
import STATUS_CODE from 'Utilities/constant/statusCode';
import UserService from 'Services/UserService';


export default {
  data() {
    return {
      first_name: null,
      last_name: null,
      email: null,
      line_phone: null,
      contact_type: 1,
      content_question: null,
    };
  },

  methods: {
    showConfirm() {
      const options = { title: this.$t('contact.title'), cancelLabel: this.$t('contact.cancel'), okLabel: this.$t('contact.confirm') };
      this.$dialogs.confirm(this.$t('contact.message'), options)
        .then(() => {
          this.create();
        });
    },
    create() {
      const params = this.parseParams();
      UserService.create(params)
        .then(() => {
          this.$router.push({ name: 'contact' });
          this.resetParams();
        })
        .catch((errors) => {
          if (errors.status === STATUS_CODE.UNPROCESSABLE_ENTITY) {
            this.$setValidationErrors(errors.status, errors.data);
          } else {
            this.message = 'Vui lòng thử lại';
          }
        });
    },

    parseParams() {
      const params = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        line_phone: this.line_phone,
        content_question: this.content_question,
        contact_type: this.contact_type,
      };
      return params;
    },

    resetParams() {
      this.first_name = null;
      this.last_name = null;
      this.email = null;
      this.line_phone = null;
      this.contact_type = 1;
      this.content_question = null;
    },
  },
};
</script>
